import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, FormControl, InputGroup, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import logo from '../../assets/images/logo/logo.png';
import sms from '../../assets/images/svg/sms.svg';
import lock from '../../assets/images/svg/lock.svg';
import oEye from '../../assets/images/svg/open-eye.svg';
import cEye from '../../assets/images/svg/close-eye.svg';
import { useNavigate } from 'react-router-dom';
import { getServerURL } from '../../helper/envConfig';
import api from "../../helper/api";
import { toast } from "react-toastify";
import { login } from "../../helper/auth";
import { errorResponse } from "../../helper/error";

const ChangePassword = () => {
    const navigate = useNavigate()
    const serverURL = getServerURL()
    const [states, setStates] = useState({ email: "maison@heera.com", password: "@123" })
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false)
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    useEffect(() => {
        document.title = " Change Password | Maison Heera"
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStates((prevValues) => ({
            ...prevValues,
            [name]: value.trimStart(),
        }));
    };

    const togglePasswordVisibility = () => {
        setShowOldPassword((prevShowPassword) => !prevShowPassword);
    };
    const togglePasswordVisibility1 = () => {
        setShowNewPassword((prevShowPassword) => !prevShowPassword);
    };

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        if (form.checkValidity()) {
            api.postWithToken(`${serverURL}auth/change-password/`, states)
                .then(async (res) => {
                    setStates({})
                    setLoading(false);
                    if (res?.data?.success === true) {
                        login(res?.data);
                        toast.success(res?.data?.message);
                        navigate("/");
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    // setLoading(false);
                    errorResponse(e);
                });
            setValidated(false);
        } else {
            setValidated(true);
            event.stopPropagation();
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setSubmitCount(1);
            handleSubmit(e);
        }
    };

    return (
        <div>
            <section className="d-flex justify-content-center align-items-center vh-100">
                <Container>
                    <Row className="justify-content-center align-items-center">
                        <Col className="col-12 col-md-7 col-lg-6 col-xl-5">
                            <Card className="pt-5">
                                <Card.Img
                                    variant="top"
                                    className="login-logo m-auto"
                                    src={logo}
                                />
                                <p className="login-title mt-3">
                                    Change Password
                                </p>
                                <Card.Body className="px-0 px-md-3">
                                    {/* onSubmit={handleSubmit} */}
                                    <Form noValidate validated={validated} onSubmit={handleSubmit} >
                                        {/* <InputGroup className="mb-3">
                                            <InputGroup.Text id="basic-addon1"><img
                                                src={sms}
                                                className="imput-img"
                                                alt="sms.svg"
                                            /></InputGroup.Text>
                                            <FormControl placeholder="Enter email address" type='email' name='email' required value={states?.email || ""} onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">Please enter email.</Form.Control.Feedback>
                                        </InputGroup> */}

                                        <InputGroup className="mb-3">
                                            <InputGroup.Text><img
                                                src={lock}
                                                className="imput-img"
                                                alt="sms.svg"
                                            /></InputGroup.Text>
                                            <FormControl placeholder="Enter old password here" type={showOldPassword ? "text" : "password"} required name='old_password' value={states?.old_password || ""} onChange={handleChange} />
                                            <InputGroup.Text> <img
                                                src={
                                                    showOldPassword
                                                        ? oEye
                                                        : cEye
                                                }
                                                className="close-eye-img cursor-pointer"
                                                alt={showOldPassword ? "open-eye.svg" : "close-eye.svg"}
                                                onClick={togglePasswordVisibility}
                                            /></InputGroup.Text>
                                            <Form.Control.Feedback type="invalid">Please enter old password.</Form.Control.Feedback>
                                        </InputGroup>
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text><img
                                                src={lock}
                                                className="imput-img"
                                                alt="sms.svg"
                                            /></InputGroup.Text>
                                            <FormControl placeholder="Enter new password here" type={showNewPassword ? "text" : "password"} required name='new_password' value={states?.new_password || ""} onChange={handleChange} />
                                            <InputGroup.Text> <img
                                                src={
                                                    showNewPassword
                                                        ? oEye
                                                        : cEye
                                                }
                                                className="close-eye-img cursor-pointer"
                                                alt={showNewPassword ? "open-eye.svg" : "close-eye.svg"}
                                                onClick={togglePasswordVisibility1}
                                            /></InputGroup.Text>
                                            <Form.Control.Feedback type="invalid">Please enter new password.</Form.Control.Feedback>
                                        </InputGroup>
                                        <p
                                            className="text-end fs-16 text-muted fw-600 cursor-pointer"
                                            onClick={() => navigate("/")}
                                        >
                                            Back to home
                                        </p>

                                        <Button className={'text-capitalize my-2 btn-glow-primary w-100 m-0 '} variant={"primary"} type='submit'
                                        // onClick={() => navigate('/users')}
                                        >
                                            {"Change Password"}
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    )
}

export default ChangePassword